module.exports = __webpack_public_path__ + "img/notOnline.67b94cbe.png";